import lozad from 'lozad';
import { onContentLoaded } from './on_content_loaded';
import { onPolyfillsLoaded } from './util/polyfills';

const LAZY_LOAD_SELECTORS = ['[data-src]', '[data-srcset]', '[data-background-image]'];
const LOZAD_OPTIONS = {
  rootMargin: '64px',
  threshold: 0,
  loaded(el) {
    // Custom implementation on a loaded element
    el.classList.add('loaded');
  }
};

let imageObserver;

export const getImageObserver = () => imageObserver;

export function observeNewImagesForLazyLoading() {
  getImageObserver().observe();
}

onContentLoaded(() => {
  // Need to load intersection observer and url-polyfill first
  onPolyfillsLoaded(() => {
    imageObserver = lozad(LAZY_LOAD_SELECTORS, LOZAD_OPTIONS);

    imageObserver.observe();
  });
});
